import axios from 'axios'

async function end_test(dispatch,data,token,setOpen,setMessage,setSubmitting,setHasStarted,setHasEnded,setIsPaused,setDiv,setTime){

try{
    setSubmitting(true)
    setIsPaused(true)

    const URL =  `${process.env.REACT_APP_SERVER_AUTH_URL}user-disqualify/` 

      const endTest = await axios.post(URL,data,{
           headers:{
                  "Content-Type":"application/json",
                  "Authorization":`Bear ${token}`
              }
       }).catch(err=>{console.log(err)})

    if (endTest?.status == 200 && endTest?.data.success) {

      setSubmitting(false)
      setMessage("You have been disqualified.You can no longer take the test after 3 warnings and you did not respect them !.");
      setOpen(true);
      setTimeout(()=>{
        setHasEnded(true)
        setHasStarted(false)
        setIsPaused(true)
        setDiv(0)
      },3000)

    }else{
      setSubmitting(false)
      setIsPaused(true)
      setMessage(endTest?.data?.message)
      setOpen(true)
    }
  }catch(err){
    console.log(err)
  }

}

export default end_test